import { EGS_CATEGORY } from '../../checklistCategories';
import { formatMoney, formatOptionalNumber, isFiniteNumber } from '../../shared/checklistUtils';
import type { ApprovalQueueItem } from '../../types';

import type { EgsCapacityChecklistRow, EgsMarginChecklistRow } from './types';

export function buildMarginQueueItem(row: EgsMarginChecklistRow): ApprovalQueueItem {
  return {
    categoryId: EGS_CATEGORY.id,
    categoryLabel: EGS_CATEGORY.label,
    description: `${row.name} has a ${row.marginBand ? `${row.marginBand} ` : ''}margin check and needs review.`,
    details: [
      { label: 'Opportunity', value: row.opportunityName || 'Opportunity not mapped' },
      { label: 'Extra guest type', value: row.extraGuestType || 'N/A' },
      { label: 'Age range', value: row.ageRange || 'N/A' },
      { label: 'Cost price', value: formatMoney(row.costPrice, row.currencyCode) },
      { label: 'Sell price', value: formatMoney(row.sellPrice, row.currencyCode) },
      { label: 'Margin', value: typeof row.margin === 'number' ? `${row.margin.toFixed(1)}%` : 'N/A' },
      { label: 'Bedding type', value: row.beddingType || 'N/A' },
      { label: 'Inclusions', value: row.inclusions || 'N/A' },
      { label: 'Collected by', value: row.collectedBy || 'N/A' },
    ],
    id: row.id,
    title: row.name,
  };
}

export function buildCapacityQueueItem(row: EgsCapacityChecklistRow): ApprovalQueueItem {
  const includedPlusEgs =
    isFiniteNumber(row.includedCapacity) && isFiniteNumber(row.egsCapacity)
      ? String(row.includedCapacity + row.egsCapacity)
      : 'N/A';

  return {
    categoryId: EGS_CATEGORY.id,
    categoryLabel: EGS_CATEGORY.label,
    description: `${row.name} capacity requires approval.`,
    details: [
      { label: 'Room asset', value: row.roomName },
      { label: 'Included capacity', value: formatOptionalNumber(row.includedCapacity) },
      { label: 'Max room capacity', value: formatOptionalNumber(row.maxRoomCapacity) },
      { label: 'EGS contracted for', value: formatOptionalNumber(row.egsCapacity) },
      { label: 'Included + EGS', value: includedPlusEgs },
    ],
    id: row.id,
    title: row.name,
  };
}

export function getMarginSearchText(row: EgsMarginChecklistRow) {
  return [
    row.name,
    row.opportunityName,
    row.extraGuestType,
    row.ageRange,
    row.currencyCode,
    row.beddingType,
    row.inclusions,
    row.collectedBy,
    row.statusLabel,
  ]
    .filter(Boolean)
    .join(' ');
}

export function getCapacitySearchText(row: EgsCapacityChecklistRow) {
  return [row.name, row.roomName, row.statusLabel].filter(Boolean).join(' ');
}
